// include team's acronyms in the description for easier search

import { CanaryStoreEntry } from '@bill/canary.react'
import { brands } from '@divvy-web/skylab.themes'

const canaryConfig: CanaryStoreEntry[] = [
  {
    name: 'theme',
    variants: ['default', ...Object.keys(brands)],
    metadata: {
      description: 'GOLD: The theme to use for the application',
      icon: '🎨',
    },
    value: 'default',
  },
  {
    description: 'when enabled, show maintenance screen',
    name: 'sputnik-maint-mode',
    value: false,
  },
  {
    description: 'when enabled, enables advanced onboarding return flow logic',
    name: 'advanced-onboarding-return-flow',
    value: false,
  },
  {
    name: 'beep-credit-application-review-page-collapsed-experiment',
    variants: [
      {
        behaviorName: 'sectionsExpanded',
        control: true,
        placement: 'QUALIFIED',
      },
      {
        behaviorName: 'sectionsCollapsed',
        placement: 'QUALIFIED',
      },
      {
        placement: 'NOT_QUALIFIED',
      },
      {
        placement: 'EXPERIMENT_OFF',
      },
    ],
    metadata: {
      description: 'COM: beep experiment attempt to collapse sections on the review page',
    },
  },
  {
    name: 'rollout-invite-collaborators-redesign',
    value: false,
    metadata: {
      description: 'COM: rollout flag for the redesign of the invite collaborators drawer',
    },
  },
  {
    name: 'beep-credit-application-accept-offer-flow-experiment',
    variants: [
      {
        behaviorName: 'presentedRedesignedOffersFlow',
        control: true,
        placement: 'QUALIFIED',
      },
      {
        behaviorName: 'presentedExistingOffersFlow',
        placement: 'QUALIFIED',
      },
      {
        placement: 'NOT_QUALIFIED',
      },
      {
        placement: 'EXPERIMENT_OFF',
      },
    ],
    metadata: {
      description: 'COM: beep experiment around our redesigned offers flow',
    },
  },
]

export default canaryConfig
